import React, { Component } from 'react'
import moment from 'moment-timezone'
import { translate } from "react-i18next"
import { connect } from 'react-redux'

import { getGridTimeslots, replaceEmptyGridRows, addDayLabels } from 'cogsworth/utils/timeslotsGrid'
import { getBookingFieldQuestion } from 'cogsworth/utils/fields'
import { setDay, setTime } from 'cogsworth/utils/store'

import './TimeSelection.css'
import { totalAvailableSlots } from '../utils/utils'

class TimeSelection extends Component {
  componentDidMount() {
    this.props.setCustomTitle(getBookingFieldQuestion("booking-time-question", this.props.business))
  }

  componentWillUnmount() {
    this.props.setCustomTitle(null)
  }

  getTimesGrid(availableTimes) {
    const { business, fetchData, timezone } = this.props

    const service = business.services.find(s => s.id === fetchData.serviceId)
    const columns = Math.max(Math.floor(60 / service.timeIncrement), 1)

    let timeslots = getGridTimeslots(availableTimes, service)

    // Replace empty rows for separators
    timeslots = replaceEmptyGridRows(timeslots, columns)

    // Add day labels
    timeslots = addDayLabels(timeslots, timezone, business.dateFormat.date)

    return {
      columns,
      times: timeslots,
      showAvailableSlotsCount: service.bookingsPerTimeslot && service.bookingsPerTimeslot > 1 && !service.hideTimeslotsSeats,
    }
  }

  handleTimeSelected(time) {
    this.props.dispatch(setTime(time))
    this.props.onTimeSelected && this.props.onTimeSelected(time)
  }

  render() {
    const { dispatch, availableTimes, t, business, day, timezone } = this.props
    const service = business.services.find(s => s.id === this.props.fetchData.serviceId)
    const timesGrid = this.getTimesGrid(availableTimes)

    if (timesGrid.times.length === 0) {
      return (
        <div className="time-selection no-availability">
          <p><strong className="oops">Oops!</strong><br />There are no available times on <strong>{ moment(day).format(business.dateFormat.date) }</strong>. Please try another date.</p>
          <br />
          <button className="btn btn-primary" onClick={() => dispatch(setDay(null))}><i className="fa fa-angle-double-left" /> { t("back-to-day-selection") }</button>
        </div>
      )
    }

    return (
      <div className={`time-selection cols-${timesGrid.columns} slots-count-${timesGrid.showAvailableSlotsCount}`}>
        <div className="time-grid">
        {
          timesGrid.times.map((timeslot, index) => {
            if (timeslot && timeslot.separator) {
              return <hr key={index}/>
            } else if (timeslot && timeslot.dayLabel) {
              return <div key={index} className="day-label">{ timeslot.dayLabel }</div>
            } else if (timeslot) {
              return <div key={index} className="time-item" onClick={() => { this.handleTimeSelected(timeslot.time) }} data-available-seats={`${totalAvailableSlots(timeslot, service)} spaces left`}>
                {moment.tz(timeslot.time, timezone).format(business.dateFormat.time)}
              </div>
            } else {
              return <div key={index} className="time-item disabled">&nbsp;</div>
            }
          })
        }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const preselectedDay = (state.page && state.page.booking_date) || null

  return {
    day: preselectedDay || state.day,
    timezone: state.timezone,
  }
}

export default connect(mapStateToProps)(translate("translations")(TimeSelection))
